import { render, staticRenderFns } from "./SettingsCMSConfigView.vue?vue&type=template&id=69af5a3b&scoped=true&"
import script from "./SettingsCMSConfigView.vue?vue&type=script&lang=js&"
export * from "./SettingsCMSConfigView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69af5a3b",
  null
  
)

export default component.exports